<app-base-notification [base]="base">
  <div [innerHTML]="'notifications.billing_plan_will_be_prolong_soon.text' | translate : {'number_of_days_for_upcoming_payment': params.number_of_days_for_upcoming_payment}"></div>
</app-base-notification>
